import { Component, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, Subject, takeUntil } from 'rxjs';
import { CoachCalendarService } from '../../../core/services/coach-calendar.service';
import { IAppointment } from '../../../core/models/appointment.model';

@Component({
  selector: 'coach-cancel-appointment-modal',
  templateUrl: './cancel-appointment-modal.component.html',
  styleUrl: './cancel-appointment-modal.component.scss',
})
export class CancelAppointmentModalComponent implements OnDestroy {
  @Input() appointment!: IAppointment;

  fg: FormGroup = this.formBuilder.group({
    reason: [null, [Validators.maxLength(500)]],
  });

  isLoading = false;

  destroyed$ = new Subject();

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private calendarService: CoachCalendarService,
  ) {
  }

  onSubmit() {
    this.isLoading = true;
    this.calendarService.cancelAppointment(this.appointment.id, this.fg.value.reason ?? undefined)
      .pipe(takeUntil(this.destroyed$), finalize(() => this.isLoading = false))
      .subscribe(() => {
        this.modal.close(true);
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
